<div class="radio-widget">
  <form>
    <div class="radio-container" *ngFor="let option of displayOptions; index as i">
      <kp-input-option
        [forId]="option.id"
        [isSelected]="option.isSelected"
        [answerText]="option.text"
        (selectInputOption)="onOptionChange($event, option)"
        [attr.data-e2e]="'radio-option-' + i"></kp-input-option>
    </div>
  </form>
</div>
